import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NotificationErrorService } from 'src/app/modules/acbcr/common/services/notification-error.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HoldingsTableService } from 'src/app/modules/acbcr/common/services/holdings-table.service'
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';

@Component({
  selector: 'app-verificare-consangvinizare',
  templateUrl: './verificare-consangvinizare.component.html',
  styleUrls: ['./verificare-consangvinizare.component.scss']
})
export class VerificareConsangvinizareComponent {
  @ViewChild('verificareConsangvinizare') verificareConsangvinizare: ElementRef;
  @Input() modalData = {};

  modalReference: NgbModalRef;
  form: UntypedFormGroup;
  numeExploatatie;
  codExploatatie;
  idExploatatie;
  loadingSpinner = false;

  constructor(
    public modalService: NgbModal,
    public errorService: NotificationErrorService,
    private holdingsTableService: HoldingsTableService,
    private helperDataService: HelperDataService,
  ) { }

  ngOnChanges(changes) {
    this.loadingSpinner = false;
    this.form = new UntypedFormGroup({
      taur: new UntypedFormControl(),
      exploatatie_id: new UntypedFormControl(),
    })

    if (changes.modalData && this.modalData && this.modalData['exploatatie']) {
      this.numeExploatatie = this.modalData['exploatatie']['name'];
      this.codExploatatie = this.modalData['exploatatie']['code'];
      this.idExploatatie = this.modalData['exploatatie']['id'];
      this.form.controls.exploatatie_id.setValue(this.idExploatatie);
      this.modalReference = this.modalService.open(this.verificareConsangvinizare);
    }
  }

  submitVerificare() {
    this.loadingSpinner = true;
    let taur = this.form.value.taur;

    this.holdingsTableService.verificareConsangvinizareAPI(this.form.value)
      .subscribe({
        next: (response) => {
          let now = UIHelper.now();
          let fisier = `Consangvinizare_${taur}_${now}.xls`;
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fisier);

          this.modalReference.close();
          this.loadingSpinner = false;
        },
        error: (errors) => {
          this.loadingSpinner = false;
        }
      });

  }
}
